
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CarrierToFilter } from './FiltersModal.vue';

@Component
export default class FilterItem extends Vue {
  @Prop({ default: () => [] }) service!: CarrierToFilter;

  @Prop({ required: false, default: true }) isServicesLevel!: boolean;

  get showItem(): boolean {
    return this.service.show;
  }

  set showItem(value: boolean) {
    this.$emit('toggleService', { value, name: this.service.name });
  }

  toggleLevel(value: boolean, name: string): void {
    this.$emit('toggleLevel', { value, serviceName: this.service.name, levelName: name });
  }
}
